import Actions from '../../odata/actions';

const actions = new Actions('quoteTemplate', 'quoteTemplates');

export default actions;
